import z from 'zod';
export const productIdValue = z.string().trim().min(1).brand('ProductId');
export const createProductId = (value) => productIdValue.parse(value);
export const isProductId = (value) => productIdValue.safeParse(value).success;
export function buildProductId(input) {
    return createProductId(`${input.stripeProductId}__${input.firmTypology}__${input.plan}`);
}
//# sourceMappingURL=product-id.js.map